<template>
  <div class="text-start" style="font-size: 18px">
    <div class="row mb-3">
      <label for="inputAccount" class="col-md-2 col-form-label">帳號</label>
      <div class="col-md-4">
        <input
          v-model="account"
          type="text"
          class="form-control"
          id="inputAccount"
          disabled
        />
      </div>
    </div>
    <div class="row mb-3">
      <label for="inputName" class="col-md-2 col-form-label">名稱</label>
      <div class="col-md-4">
        <input
          v-model="username"
          type="text"
          class="form-control"
          id="inputName"
          disabled
        />
      </div>
    </div>
    <div class="row mb-3">
      <label for="inputOrgPassword" class="col-md-2 col-form-label"
        >原密碼</label
      >
      <div class="col-md-4">
        <input
          v-model="password"
          type="password"
          class="form-control"
          id="inputOrgPassword"
        />
      </div>
    </div>
    <div class="row mb-3">
      <label for="inputNewPassword" class="col-md-2 col-form-label"
        >新密碼</label
      >
      <div class="col-md-4">
        <input
          v-model="newPassword"
          type="password"
          class="form-control"
          id="inputNewPassword"
        />
      </div>
    </div>
    <div class="row mb-3">
      <label for="inputCheckNewPassword" class="col-md-2 col-form-label"
        >確認新密碼</label
      >
      <div class="col-md-4">
        <input
          v-model="checkNewPassword"
          type="password"
          class="form-control"
          id="inputCheckNewPassword"
        />
      </div>
      <div v-if="passwordsMatch == false" class="form-text" style="color: red">
        請確認新密碼，新密碼不一致
      </div>
    </div>
  </div>
  <div class="gap-2 d-md-flex justify-content-md-end">
    <button
      type="button"
      class="btn p-0 me-2"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 6rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      @click="cancelUpdate"
    >
      取消
    </button>
    <button
      type="button"
      class="btn p-0"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 6rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      :disabled="!passwordsMatch"
      @click="checkUpdate(account, password, newPassword, checkNewPassword)"
    >
      確認修改
    </button>
  </div>
</template>

<script>
import { computed, inject, ref, watch } from "vue";
import store from "@/store";
export default {
  setup() {
    const mod = inject("mod");
    const commonMethods = inject("commonMethods");

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);

    const checkUpdate = commonMethods.checkUpdate;
    const cancelUpdate = commonMethods.cancelUpdate;

    const account = ref(loginData.value.account);
    const username = ref(loginData.value.username);

    const password = ref();
    const newPassword = ref("");
    const checkNewPassword = ref("");
    const passwordsMatch = ref(null);

    let validationTimeout = null; //密碼檢查逾時計時器

    const validatePasswords = () => {
      if (newPassword.value == "" || checkNewPassword.value == "") {
        return;
      }
      if (newPassword.value === checkNewPassword.value) {
        passwordsMatch.value = true;
      } else {
        passwordsMatch.value = false;
      }
    };
    const scheduleValidation = () => {
      if (validationTimeout) {
        clearTimeout(validationTimeout);
      }

      validationTimeout = setTimeout(() => {
        validatePasswords();
      }, 500);
    };

    watch([newPassword, checkNewPassword], () => {
      scheduleValidation();
    });

    return {
      mod,
      checkUpdate,
      cancelUpdate,
      account,
      username,
      password,
      newPassword,
      checkNewPassword,
      passwordsMatch,
      validatePasswords,
    };
  },
};
</script>

<style></style>
